export const BASE_URL = `${document.location.protocol}//${document.location.host}`;

export const ZEN_DOWNLOAD_APP_URL = 'https://zenbusiness.onelink.me/NDnu/tsy80nrx';

export const BANK_OF_AMERICA_OFFER_URL =
  'https://promotions.bankofamerica.com/smallbusiness/alliance/terms';

export const MERCURY_REFERRAL_URL = 'https://mercury.com/partner/zenbusiness';

export const MERCURY_REFERRED_CUSTOMER_AGREEMENT_URL =
  'https://mercury.com/legal/referred-customer-agreement';
